import React from 'react'
import { withTheme } from 'styled-components'

import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { MoreHelpFooterContainer } from '../../containers'

import messages from './messages'
import ContentPanel from './ContentPanel'
import { StartGrid } from './styles'

const GettingStarted = ({
  currentPhone,
  language,
  startercontent,
  query,
  createUserEvent
}) => {
  const translated = messages[language]
  const contentTypes = ['tutorial', 'faq', 'guide', 'video']
  let panels = []
  let panelIndex = 0
  contentTypes.map((type, i) => {
    let list =
      startercontent &&
      startercontent.filter(content => content.contentType === type)
    if (list.length) {
      panels.push(
        <ContentPanel
          key={i}
          contentList={list}
          title={translated[`${type}Title`]}
          subtitle={translated[`${type}Sub`]}
          index={panelIndex + 1}
          align={panelIndex % 2 === 0 ? 'left' : 'right'}
          currentPhone={currentPhone}
          createUserEvent={createUserEvent}
          query={query}
        />
      )
      panelIndex++
    }
    return false
  })

  return (
    <div>
      <StartGrid id="start-grid">{panels}</StartGrid>
      <MoreHelpFooterContainer />
    </div>
  )
}

export default LanguageProvider(withTheme(GettingStarted))



// WEBPACK FOOTER //
// ./src/components/GettingStarted/GettingStarted.js